import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import {
  IApplicationPerformanceKpis,
  IApplicationPerformanceKpisPerUser,
  IApplicationPerformanceKpisPerUserGroup,
} from '@pages/admin/admin-event-analytics/admin-event-analytics.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationPerformanceService {
  constructor(private readonly http: HttpClient) {}

  public getApplicationPerformance(params?: HttpParams): Observable<IApplicationPerformanceKpis> {
    return this.http.get<IApplicationPerformanceKpis>('application-performance', { params });
  }

  public getApplicationPerformanceByUserGroup(
    params?: HttpParams,
  ): Observable<IApiResponse<IApplicationPerformanceKpisPerUserGroup[]>> {
    return this.http.get<IApiResponse<IApplicationPerformanceKpisPerUserGroup[]>>(
      'application-performance/by-user-group',
      { params },
    );
  }

  public getApplicationPerformanceByUser(
    params?: HttpParams,
  ): Observable<IApiResponse<IApplicationPerformanceKpisPerUser[]>> {
    return this.http.get<IApiResponse<IApplicationPerformanceKpisPerUser[]>>('application-performance/by-user', {
      params,
    });
  }
}
